import { app } from '../../app';

app.component('uploadResultTable', {
    bindings: {importResult: '<'},
    templateUrl: require('./upload-result-table.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/upload-result-table/upload-result-table.component.js